import { OptionType } from 'spa/member/components/Select/types'
import { officeDaysOfWeekOptions } from 'spa/member/components/WorkPreference/constants'

export const generateHoursPerWeekOptions = (min: number, max: number, step: number, unit: string = ''): OptionType[] => {
  const numberOptions = Array.from({ length: (max - min) / step + 1 }, (_, i) => {
    const number = min + i * step

    return {
      label: `${number}${unit}`,
      value: number.toString()
    }
  })

  return [{ label: '選択してください', value: '' }, { label: `${min - 1}時間以下`, value: `${min - 1}` }, ...numberOptions]
}

// 稼働先オフィスへの出社が可能な曜日の選択肢のうち「なし」だけを非活性にする
// disableNoneOption が true のときは毎回新しい配列を返すため、呼び出し側では useMemo で包むこと
export const buildOfficeDaysOfWeekOptions = (disableNoneOption: boolean) => {
  if (!disableNoneOption) return officeDaysOfWeekOptions

  return officeDaysOfWeekOptions.map(option =>
    option.type === 'reset' ? { ...option, disabled: true } : option
  )
}
